import { getRemainingBand } from './highTimeComponentUtils';

export function getCalendarBand(days) {
    if (days == null || days === '') return null;
    const num = Number(days);
    if (!Number.isFinite(num)) return null;
    if (num < 0) return 'overdue';
    if (num <= 30) return 'critical';
    return 'remaining';
}

export function getHoursBand(hours) {
    if (hours == null || hours === '') return null;
    const num = Number(hours);
    if (!Number.isFinite(num)) return null;
    return getRemainingBand(num);
}

export function remainingCellColor(band, fallback) {
    if (band === 'overdue') return '#dc3545';
    if (band === 'critical') return '#e67e00';
    if (band === 'watch') return '#c9a000';
    return fallback;
}

export function formatHoursRemaining(value) {
    if (value == null || value === '') return '—';
    const num = Number(value);
    return Number.isFinite(num) ? num.toFixed(1) : '—';
}

export function formatDaysRemaining(value) {
    if (value == null || value === '') return '—';
    const num = Number(value);
    return Number.isFinite(num) ? String(num) : '—';
}

export function formatDueDate(value) {
    if (!value) return '—';
    const text = String(value).slice(0, 10);
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(text);
    if (!match) return text;
    return `${Number(match[2])}/${Number(match[3])}/${match[1]}`;
}

export function filterBunos(bunos, search) {
    const q = (search || '').trim().toLowerCase();
    if (!q) return bunos || [];
    return (bunos || []).filter(row => {
        const buno = String(row.buno || '').toLowerCase();
        const modex = String(row.modex || '').toLowerCase();
        return buno.includes(q) || modex.includes(q);
    });
}

export function filterAircraftItems(items, search) {
    const q = (search || '').trim().toLowerCase();
    if (!q) return items || [];
    return (items || []).filter(item => (
        [item.nomen, item.pn, item.pos_cd, item.serno, item.bl_no_ind_cd]
            .some(value => String(value || '').toLowerCase().includes(q))
    ));
}

export function aircraftComponentLifePath(buno, siteName) {
    const params = new URLSearchParams();
    if (buno) params.set('buno', buno);
    if (siteName) params.set('site_name', siteName);
    const qs = params.toString();
    return `/reports/aircraft-component-life${qs ? `?${qs}` : ''}`;
}
